import { Col, Row, Input, Button, Upload, Modal } from "antd";
// import { memo, useState } from "react";
// import { Col, Row, Input } from "antd";
import { memo, useEffect, useState, useRef } from "react";
import { Icon } from "@iconify/react";
import ChatBody from "./ChatBody";
import AvatarAboutDrawer from "./AvatarAboutDrawer";
import AvatarShare from "./AvatarShare";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { updateLastWord } from "../../Slice/slice";
import {
  startConversation,
  pinnedAvatar,
  getEmbeddingfile,
  getFilecheck,
  multifileuploads3,
} from "../../api/accountAction";
import {
  setChatMessage,
  deleteChatMessage,
  setLibraryQuestion,
  setChatSessionID,
  setTempChatSessionID,
  setPinnedStatus,
} from "../../Slice/reducer/chatReducer";
import AWS from "aws-sdk";
import AudioToText from "./AudioToText";

import {
  getCurrentDayAndTime,
  generateTransactionId,
  htmlRemove,
  generateRandomFourDigitNumber,
  formatCurrentTime,
  generateUUID,
} from "../../customhook/CustomHoom";
import LanguageSelector from "./LanguageSelector";
import { getpinnedavatar } from "../Auth/ConversationAuth";
AWS.config.update({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  region: process.env.REACT_APP_AWS_REGION,
  signatureVersion: process.env.REACT_APP_AWS_SIGNATURE_VERSION,
});

const ChatPart = () => {
  const { id } = useParams();
  const s3 = new AWS.S3();
  const [drawerstatus, setDrawarStatus] = useState(false);
  const [aibuttonstatue, setAiButtonStatus] = useState(true);
  const childRef = useRef(null);
  // const { avatardetails, chatmessage } = useSelector((state) => state.chat);
  const [message, setMessage] = useState("");
  const [fileModalOpen, setFileModalOpen] = useState(false);
  const [micvisiblestatus, setMicVisibleStatus] = useState(true);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [helpkeystatus, setHelpKeyStatus] = useState(false);
  const [fileupload, setFileUpload] = useState();
  const [messages, setMessages] = useState([]);
  const [open, setOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [sessionid, setSessionID] = useState("");
  const [uniqueid, setUniqueid] = useState(generateUUID());
  const {
    avatardetails,
    libraryquestion,
    chat_session_id,
    temp_chat_session_id,
    pinnedstatus,
    latestavatar,
  } = useSelector((state) => state.chat);
  const { chatmessage } = useSelector((state) => state.chat);
  const [messageprocessstatus, setMessageProcessStatus] = useState(true);
  const [pinnedavatarstatus, setPinnedAvatarStatus] = useState(false);
  const dispatch = useDispatch();
  const lastWord = useSelector((state) => state.lastword);
  const [parentState, setParentState] = useState(false);

  useEffect(() => {
    if (lastWord) {
      setMessage(lastWord);
      getDetails();
    }
  }, [lastWord]);

  const companyName = atob(
    localStorage.getItem("AIVolveXIdentityServiceProvider.com")
  );
  const userName = atob(
    localStorage.getItem("AIVolveXIdentityServiceProvider.auth")
  );

  useEffect(() => {
    setMessage(libraryquestion);
  }, [libraryquestion]);

  useEffect(() => {
    dispatch(setTempChatSessionID(generateTransactionId()));
    if (avatardetails.pinned_status === "pinned") {
      setPinnedAvatarStatus(true);
    } else {
      setPinnedAvatarStatus(false);
    }
  }, [id]);
  const getDetails = () => {
    getStartConversation();
    setAiButtonStatus(true);
    dispatch(updateLastWord(""));
  };

  const getStartConversation = () => {
    if (messageprocessstatus && message.trim() !== "") {
      var chatsessionid;
      var temp_chatsesssion_id = temp_chat_session_id;
      setMessageProcessStatus(false);
      if (chat_session_id !== "") {
        chatsessionid = chat_session_id;
      } else {
        chatsessionid = generateTransactionId();

        dispatch(setChatSessionID(chatsessionid));
      }

      var temp_chatsesssion_id;
      if (temp_chat_session_id !== "") {
        temp_chatsesssion_id = temp_chat_session_id;
      } else {
        temp_chatsesssion_id = generateTransactionId();
        dispatch(setTempChatSessionID(temp_chatsesssion_id));
      }

      const chatinput = htmlRemove(message);
      var chatmessage_message = chatinput;
      setMessage("");
      dispatch(setLibraryQuestion(""));
      //user question
      const old_record_lenght = chatmessage.length;
      const avatar_chat_details_user = {
        id: +old_record_lenght + +1,
        text: chatinput,
        user: true,
        date: getCurrentDayAndTime(),
        type: "message",
      };
      dispatch(setChatMessage(avatar_chat_details_user));
      //bot ans
      const new_message_id = +old_record_lenght + +2;
      const avatar_chat_details = {
        id: new_message_id,
        text: "",
        user: false,
        date: getCurrentDayAndTime(),
        type: "message",
        message_list: [],
        source: true,
        image: avatardetails.avatar_image,
        avatar_name: avatardetails.avatar_name,
        conversection_id: 0,
      };
      dispatch(setChatMessage(avatar_chat_details));
      const streaming_unique_id = generateUUID();
      childRef.current.openWebsocket(
        new_message_id,
        streaming_unique_id,
        generateUUID()
      );

      // const avatar_chat_details_loader = {
      //   text: "",
      //   user: false,
      //   date: getCurrentDayAndTime(),
      //   type: "loader",
      // };
      // dispatch(setChatMessage(avatar_chat_details_loader));

      const input = {
        user_session: chatsessionid,
        avatar_id: id,
        chat: chatmessage_message,
        schema: companyName,
        user_name: userName,
        temp_session_id: temp_chatsesssion_id,
        avatar_name: avatardetails.avatar_name,
        pod_name: avatardetails.pod,
        streaming_id: streaming_unique_id,
        jwt_token: localStorage.getItem("_token"),
      };
      //

      dispatch(startConversation(input))
        .unwrap()
        .then(({ data }) => {
          // console.log(data);
          // dispatch(deleteChatMessage());
          // const result = JSON.parse(data.aivolvex_control_plane);
          //
          // const responce = result.answer;
          // setMessageProcessStatus(true);
        })
        .catch((err) => {
          // dispatch(deleteChatMessage());
          // const avatar_chat_details = {
          //   text: "I'm sorry, I'm unable to comprehend your question. Can you please provide more specific information or ask a different question?",
          //   user: false,
          //   date: getCurrentDayAndTime(),
          //   type: "message",
          //   image: avatardetails.avatar_image,
          // };
          // dispatch(setChatMessage(avatar_chat_details));
          // setMessageProcessStatus(true);
        });
    }
  };

  const handleKeyPress = (event) => {
    if (message.length > 0) {
      if (event.key === "Enter") {
        event.preventDefault();
        getStartConversation();
      }
    }
  };
  function generateUniqueID() {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const randomFourDigitNumber = generateRandomFourDigitNumber();
    return `${year}${month}${day}-${randomFourDigitNumber}`;
  }
  let timer;
  const stopTimer = () => {
    clearInterval(timer);
  };

  const handleNoResponse = (uniqueID) => {
    let timerId;
    timerId = setInterval(async () => {
      try {
        const input = {
          user_session: temp_chat_session_id,
          company: companyName,
          unique_id: uniqueID,
        };
        const { data } = await dispatch(getFilecheck(input)).unwrap();
        if (data) {
          dispatch(deleteChatMessage());
          const avatar_chat_details = {
            text: "File analysis is complete! 'You can now inquire about the file's contents...",
            user: false,
            date: getCurrentDayAndTime(),
            type: "message",
            image: avatardetails.avatar_image,
            message_list: [],
          };
          setMessageProcessStatus(true);
          dispatch(setChatMessage(avatar_chat_details));
          clearInterval(timerId);
        }
      } catch (error) {
        console.error("Error checking file status:", error);
      }
    }, 15000);
  };
  const handleFileUpload = (event) => {
    const files = selectedFiles.map((fileInfo) => ({
      file: fileInfo,
    }));
    const selectedFile = files;
    setFileUpload(selectedFile);
    handlefileOk(selectedFile, temp_chat_session_id);
    setFileModalOpen(false);
    setSelectedFiles([]);
  };
  // const handlefileOk = (selectedFile, temp_chat_session_id) => {
  //   const uniqueID = generateUniqueID();
  //   const params = selectedFile.map((fileDetail) => ({
  //     // Bucket: "1ch-dev-embedding-input-bucket",
  //     Bucket: avatardetails.bucket_name,
  //     Key: `${temp_chat_session_id}/${uniqueID}/${fileDetail.file.name}`,
  //     Body: fileDetail.file.originFileObj,
  //   }));
  //   stopTimer();
  //   handleAWSFileUpload(params, uniqueID, temp_chat_session_id);
  // };
  const handlefileOk = async (selectedFile, temp_chat_session_id) => {
    const uniqueID = generateUniqueID();

    const convertFileToBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.split(",")[1]);
        reader.onerror = (error) => reject(error);
      });
    };

    try {
      const base64Files = await Promise.all(
        selectedFile.map((fileDetail) =>
          convertFileToBase64(fileDetail.file.originFileObj)
        )
      );

      const params = base64Files.map((base64File, index) => ({
        bucket_name: avatardetails.bucket_name,
        file_name: `${temp_chat_session_id}/${uniqueID}/${selectedFile[index].file.name}`,
        file_content: base64File,
        content_type: "multipart/form-data",
      }));

      stopTimer();
      handleAWSFileUpload(params, uniqueID, temp_chat_session_id);
    } catch (error) {
      console.error("Error converting files to base64: ", error);
    }
  };

  const handleAWSFileUpload = async (
    params,
    uniqueID,
    temp_chat_session_id
  ) => {
    try {
      //
      const filegroup = {
        files: params,
      };
      dispatch(multifileuploads3(filegroup))
        .unwrap()
        .then(({ data }) => {
          const value = JSON.parse(data);
        })
        .catch((err) => {
          console.log(err);
        });
      // const uploadPromises = params.map(async (param) => {
      //   await s3.upload(param).promise();
      // });
      setMessageProcessStatus(false);
      const avatar_chat_details = {
        text: "File Uploaded Successfully! currently processing the file. Please wait while it's being analyzed..",
        user: false,
        date: getCurrentDayAndTime(),
        type: "message",
        image: avatardetails.avatar_image,
        message_list: [],
      };
      dispatch(setChatMessage(avatar_chat_details));

      const avatar_chat_details_loader = {
        text: "",
        user: false,
        date: getCurrentDayAndTime(),
        type: "loader",
      };
      dispatch(setChatMessage(avatar_chat_details_loader));
      const input = {
        user_session: temp_chat_session_id,
        company: companyName,
        unique_id: uniqueID,
        avatar_id: id,
        user_id: userName,
      };
      setTimeout(() => {
        dispatch(getEmbeddingfile(input))
          .unwrap()
          .then(({ data }) => {
            dispatch(deleteChatMessage());
            const value = JSON.parse(data.aivolvex_control_plane);
            const avatar_chat_details = {
              text: "File analysis is complete! 'You can now inquire about the file's contents...",
              user: false,
              date: getCurrentDayAndTime(),
              type: "message",
              image: avatardetails.avatar_image,
              message_list: [],
            };
            setMessageProcessStatus(true);
            dispatch(setChatMessage(avatar_chat_details));
          })
          .catch((err) => {
            handleNoResponse(uniqueID);
          });
      }, 2000);
    } catch (error) {
      console.error("Error uploading files to S3:", error);
    }
  };
  const handleCancel = () => {
    setFileModalOpen(false);
    setSelectedFiles([]);
    setErrorMessage(false);
  };
  const setPinnedAvatar = () => {
    var pin_status = "pin";
    var pinmessage = "Agent Pinned";
    if (avatardetails.pinned_status === "pinned") {
      pin_status = "unpin";
      pinmessage = "Agent Unpinned";
    }

    const input = {
      avatar_id: id,
      company: companyName,
      user_id: userName,
      pin_status: pin_status,
      type: "private",
    };
    getpinnedavatar(dispatch, input, pinnedstatus, pinmessage);
  };

  const currentTime = formatCurrentTime();
  return (
    <>
      {drawerstatus && (
        <AvatarAboutDrawer
          drawerstatus={drawerstatus}
          setDrawarStatus={setDrawarStatus}
        />
      )}
      <Row>
        <Col span={24}>
          <Row className="volvex-chat-header">
            <Col span={24}>
              <div className="d-flex justify-content-between">
                <div className="d-flex justify-content-start">
                  <div>
                    <img
                      src={avatardetails.avatar_image}
                      alt="avatar-img"
                      className="volvex-chat-header-avatar-logo"
                    />
                  </div>
                  <div className="volvex-chat-avatar-title">
                    <label className="aivolvex-font">
                      {/* {avatardetails.avatar_name} */}
                      {latestavatar ? latestavatar : avatardetails.avatar_name}
                    </label>

                    <div>
                      <Icon
                        onClick={() => {
                          setPinnedAvatar();
                        }}
                        icon="fluent-mdl2:pinned"
                        className={
                          avatardetails.pinned_status === "pinned"
                            ? "volvex-chat-header-icon cursor-pointer pinned-color"
                            : "volvex-chat-header-icon cursor-pointer"
                        }
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <label>
                    Mic : <LanguageSelector subclass="mic-language" />
                  </label>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="volvex-chat-list-body">
            <ChatBody
              ref={childRef}
              setMessageProcessStatus={setMessageProcessStatus}
              setParentState={setParentState}
            />
          </Row>
          <Row className="volvex-chat-list-footer">
            <Col span={24}>
              <Row>
                <Col span={24}>
                  <div class="input-container">
                    <Input.TextArea
                      value={message}
                      onChange={(e) => {
                        setMessage(e.target.value);
                      }}
                      autoSize={{ minRows: 1 }}
                      className="input-container-textarea aivolvex-font"
                      onKeyPress={handleKeyPress}
                    />
                    {avatardetails.type === "prometheus" ||
                    avatardetails.type === "image" ? (
                      <label
                        htmlFor="file-input"
                        className="custom-file-upload d-flex justify-content-center align-items-center"
                      >
                        <span
                          className="upload-icon"
                          onClick={() => setFileModalOpen(true)}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 35 35"
                            className="upload-mb"
                          >
                            <path d="M9.39779 12.8066H12.9398V23.3141C12.9398 24.3802 13.8042 25.2435 14.8692 25.2435H20.1355C21.2004 25.2435 22.0649 24.3803 22.0649 23.3141V12.8066H25.6057C26.1923 12.8066 26.7196 12.4534 26.9452 11.9113C27.1684 11.3715 27.0442 10.7473 26.6298 10.3329L18.5262 2.22831C17.9602 1.66348 17.0433 1.66348 16.4761 2.22831L8.37391 10.3329C7.95937 10.7473 7.83517 11.3704 8.0596 11.9113C8.28502 12.4524 8.81119 12.8066 9.39779 12.8066Z" />
                            <path d="M33.2597 16.7449C32.2995 16.7449 31.5206 17.5239 31.5206 18.4851V25.7617C31.5206 27.9415 29.7461 29.7148 27.5662 29.7148H7.43365C5.25376 29.7148 3.48049 27.9415 3.48049 25.7617V18.4851C3.48049 17.5239 2.70036 16.7449 1.74024 16.7449C0.778989 16.7449 0 17.5239 0 18.4852V25.7618C0 29.8606 3.33467 33.1954 7.43365 33.1954H27.5662C31.6652 33.1954 35 29.8607 35 25.7618V18.4852C35 17.5239 34.2209 16.7449 33.2597 16.7449Z" />
                          </svg>
                        </span>
                      </label>
                    ) : (
                      <></>
                    )}
                    {micvisiblestatus && (
                      <AudioToText
                        setMessage={setMessage}
                        setMicVisibleStatus={setMicVisibleStatus}
                        micvisiblestatus={micvisiblestatus}
                      />
                    )}

                    {!parentState ? (
                      <>
                        <button
                          onClick={() => getStartConversation()}
                          className="volvex-submit-btn d-flex justify-content-center align-items-center"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 41 41"
                            className="volvex-submit-btn-icon"
                          >
                            <path d="M3.84375 35.875L37.1562 20.5L3.84375 5.125V17.0833L27.707 20.5L3.84375 23.9167V35.875Z" />
                          </svg>
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          onClick={() => {
                            childRef.current.tempStopStreaming();
                          }}
                          className="volvex-submit-btn d-flex justify-content-center align-items-center"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="1.5em"
                            height="1.5em"
                            viewBox="0 0 72 72"
                          >
                            <g
                              fill="none"
                              stroke="#000"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-width="2"
                            >
                              <path d="M44.388 14.73H27.612a1 1 0 0 0-.707.292L15.043 26.884a1 1 0 0 0-.293.707v16.776a1 1 0 0 0 .293.707l11.862 11.862a1 1 0 0 0 .707.293h16.776a1 1 0 0 0 .707-.293l11.862-11.862a1 1 0 0 0 .293-.707V27.591a1 1 0 0 0-.293-.707L45.095 15.022a1 1 0 0 0-.707-.293" />
                              <path d="M39.323 39.5a2.5 2.5 0 0 1-2.5-2.5v-2a2.5 2.5 0 0 1 2.5-2.5h0a2.5 2.5 0 0 1 2.5 2.5v2a2.5 2.5 0 0 1-2.5 2.5m-13.178-5.606c-.205-.797-1.091-1.397-2.153-1.397h0c-1.214 0-2.198.783-2.198 1.75c0 .966.984 1.75 2.198 1.75l-.045.006c1.214 0 2.198.784 2.198 1.75s-.984 1.75-2.198 1.75h0c-1.062 0-1.948-.6-2.153-1.397m7.852-5.606h4m-2 0v7m14.148 0v-7h2.669c.963 0 1.743.78 1.743 1.744h0c0 .962-.78 1.743-1.743 1.743h-2.67" />
                            </g>
                            <path
                              fill="#D22F27"
                              d="M45.941 10.98H26.06a1 1 0 0 0-.707.292l-14.06 14.059a1 1 0 0 0-.292.707V45.92a1 1 0 0 0 .293.707l14.059 14.06a1 1 0 0 0 .707.292h19.88a1 1 0 0 0 .707-.293l14.06-14.059A1 1 0 0 0 61 45.92V26.038a1 1 0 0 0-.293-.707L46.648 11.272a1 1 0 0 0-.707-.293"
                            />
                            <path
                              fill="none"
                              stroke="#FFF"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-width="2"
                              d="M44.388 14.73H27.612a1 1 0 0 0-.707.292L15.043 26.884a1 1 0 0 0-.293.707v16.776a1 1 0 0 0 .293.707l11.862 11.862a1 1 0 0 0 .707.293h16.776a1 1 0 0 0 .707-.293l11.862-11.862a1 1 0 0 0 .293-.707V27.591a1 1 0 0 0-.293-.707L45.095 15.022a1 1 0 0 0-.707-.293"
                            />
                            <path
                              fill="none"
                              stroke="#FFF"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-width="2"
                              d="M39.323 39.5a2.5 2.5 0 0 1-2.5-2.5v-2a2.5 2.5 0 0 1 2.5-2.5h0a2.5 2.5 0 0 1 2.5 2.5v2a2.5 2.5 0 0 1-2.5 2.5m-13.178-5.606c-.205-.797-1.091-1.397-2.153-1.397h0c-1.214 0-2.198.783-2.198 1.75c0 .966.984 1.75 2.198 1.75l-.045.006c1.214 0 2.198.784 2.198 1.75s-.984 1.75-2.198 1.75h0c-1.062 0-1.948-.6-2.153-1.397m7.852-5.606h4m-2 0v7m14.148 0v-7h2.669c.963 0 1.743.78 1.743 1.744h0c0 .962-.78 1.743-1.743 1.743h-2.67"
                            />
                            <path
                              fill="none"
                              stroke="#000"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-width="2"
                              d="M45.941 10.98H26.06a1 1 0 0 0-.707.292l-14.06 14.059a1 1 0 0 0-.292.707V45.92a1 1 0 0 0 .293.707l14.059 14.06a1 1 0 0 0 .707.292h19.88a1 1 0 0 0 .707-.293l14.06-14.059A1 1 0 0 0 61 45.92V26.038a1 1 0 0 0-.293-.707L46.648 11.272a1 1 0 0 0-.707-.293"
                            />
                          </svg>
                        </button>
                      </>
                    )}
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      <Modal open={fileModalOpen} footer={false} onCancel={handleCancel} className="file-upload-modal">
        <>
          <Upload
            multiple
            fileList={selectedFiles}
            className="upload-file-pdf"
            onChange={(info) => {
              if (info.file.type === "application/pdf") {
                setSelectedFiles(info.fileList);
                setErrorMessage("");
              } else {
                setErrorMessage("Only PDF files are allowed for upload.");
              }
            }}
          >
            <Button className="select-file">
              <Icon icon="line-md:upload-loop" className="upload-file-icon" />
              Select Files
            </Button>
            <br />
          </Upload>
          {errorMessage && <div style={{ color: "red" }}>{errorMessage}</div>}
          <br />
          {selectedFiles.length > 0 && (
            <Button
              onClick={handleFileUpload}
              type="primary"
              className="upload-file "
            >
              {selectedFiles.length > 1 ? "Upload Files" : "Upload File"}
            </Button>
          )}
        </>
      </Modal>
    </>
  );
};

export default memo(ChatPart);
